<div class="td-indicator-view">
  <div class="td-tabs-card" *ngIf="tabItems.length">
    <p-tabMenu [model]="tabItems" [activeItem]="activeTabItem" styleClass="td-tab-menu">
      <ng-template let-item pTemplate="item">
        <span class="td-tab-dot" [ngStyle]="{'background-color': item.state.color}"></span>
        <span class="td-tab-label">{{ item.label }}</span>
      </ng-template>
    </p-tabMenu>
  </div>

  <div class="spinner-border text-primary td-indicator-spinner" role="status" *ngIf="loading"></div>

  <ng-container *ngIf="!loading">
    <ng-container *ngIf="detail as detail; else noDetail">
      <div class="td-card td-indicator-header-card">
        <div class="td-indicator-identity">
          <span class="td-indicator-icon" [ngStyle]="{'background-color': detail.color}">
            <span class="td-indicator-icon-glyph" [ngStyle]="iconStyle"></span>
          </span>
          <div class="td-indicator-title-group">
            <span class="td-indicator-title">{{ detail.title }}</span>
            <span class="td-indicator-description">{{ detail.description }}</span>
          </div>
        </div>

        <div class="td-indicator-summary">
          <div class="td-indicator-gauge">
            <div class="td-indicator-score">
              <span class="td-indicator-score-value">{{ detail.score }}</span>
              <span class="td-indicator-score-unit">%</span>
            </div>
            <div class="td-indicator-change">
              <img class="td-indicator-change-arrow" *ngIf="detail.trend"
                   [src]="'../../../assets/svg/indicator-arrow-' + detail.trend + '.svg'" alt="">
              <i class="bi bi-dash-lg td-indicator-change-dash" *ngIf="!detail.trend"></i>
              <span class="td-indicator-change-diff"
                    [ngClass]="detail.trend ? detail.trend : ''">{{ (detail.diff !== null ? detail.diff : 0) }}%</span>
              <span class="td-indicator-change-label">{{ 'td_overall_score_change' | translate }}</span>
            </div>
          </div>

          <div class="td-indicator-stats">
            <div class="td-indicator-stats-top">
              <span class="td-indicator-stats-label">{{ 'td_indicator_teams_affected' | translate }}</span>
              <span class="td-indicator-stats-value">{{ detail.teamsAffected }} / {{ detail.teamsTotal }}</span>
            </div>
            <div class="td-indicator-stats-track">
              <span class="td-indicator-stats-fill"
                    [ngStyle]="{'width': detail.affectedPercentage + '%', 'background-color': detail.color}"></span>
            </div>
            <span class="td-indicator-stats-caption">
              {{ 'td_indicator_teams_below_target' | translate : {count: detail.teamsAffected} }}
            </span>
          </div>
        </div>
      </div>

      <div class="td-indicator-cards-row">
        <app-score-development class="td-card-slot"
                               titleKey="td_indicator_score_over_time"
                               [showChips]="false"
                               [scores]="scoreDevelopment"
                               [chips]="chartChips"
                               [activeChipUuid]="detail.uuid"
                               [loading]="loading">
        </app-score-development>

        <div class="td-card td-distribution-card">
          <div class="td-card-header">
            <span class="td-card-title">{{ 'td_indicator_score_distribution' | translate }}</span>
            <span class="td-distribution-meta">
              {{ 'td_indicator_teams_count' | translate : {count: detail.teamsTotal} }}
            </span>
          </div>

          <div class="td-distribution-body">
            <div class="td-distribution-bar">
              <span class="td-distribution-segment"
                    *ngFor="let segment of detail.distribution; trackBy: trackByColorName"
                    [ngStyle]="{'flex-grow': segment.percentage, 'background-color': segment.color}"
                    [pTooltip]="'td_indicator_teams_count' | translate : {count: segment.teams}"
                    tooltipPosition="top" tooltipStyleClass="tooltip-style"></span>
            </div>
            <div class="td-distribution-labels">
              <span class="td-distribution-label"
                    *ngFor="let segment of distributionLabels; trackBy: trackByColorName"
                    [ngStyle]="{'flex-grow': segment.percentage, 'color': segment.color}">{{ segment.percentage }}%</span>
            </div>
          </div>

          <div class="td-distribution-footer">
            <span class="td-distribution-switch-label">{{ 'td_indicator_visible_to_team' | translate }}</span>
            <p-inputSwitch [(ngModel)]="visibleToTeam"></p-inputSwitch>
          </div>
        </div>
      </div>

      <app-indicator-statements [data]="statements"
                                [loading]="loadingStatements"
                                [responses]="statementResponses"
                                (filtersChanged)="onStatementFiltersChanged($event)"
                                (statementOpened)="onStatementOpened($event)">
      </app-indicator-statements>
    </ng-container>

    <ng-template #noDetail>
      <div class="td-card td-indicator-empty">
        <span>{{ 'td_no_data' | translate }}</span>
      </div>
    </ng-template>
  </ng-container>
</div>
